import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Lenis from "lenis";
import "@/App.css";

import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import PreventionBar from "@/components/layout/PreventionBar";
import AgeGate from "@/components/layout/AgeGate";
import CookieBanner from "@/components/layout/CookieBanner";
import ArticleLayout from "@/components/ArticleLayout";
import Home from "@/pages/Home";
import Glossaire from "@/pages/Glossaire";
import JeuResponsable from "@/pages/JeuResponsable";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";
import Recherche from "@/pages/Recherche";

import { ARTICLES_COMPRENDRE } from "@/data/articlesComprendre";
import { ARTICLES_LEGAL } from "@/data/articlesLegal";
import { ARTICLES_DEMARRER } from "@/data/articlesDemarrer";
import { PAGES_SIMPLES } from "@/data/pagesSimples";
import { ARTICLE_COMBINES } from "@/data/articleCombines";

const ALL_ARTICLES = [
  ...ARTICLES_COMPRENDRE,
  ARTICLE_COMBINES,
  ...ARTICLES_LEGAL,
  ...ARTICLES_DEMARRER,
  ...PAGES_SIMPLES,
];

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 150);
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ duration: 1.05, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollManager />
        <AgeGate />
        <div className="flex min-h-screen flex-col bg-white">
          <Header />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              {ALL_ARTICLES.map((a) => (
                <Route key={a.path} path={a.path} element={<ArticleLayout article={a} />} />
              ))}
              <Route path="/comprendre/glossaire" element={<Glossaire />} />
              <Route path="/jeu-responsable" element={<JeuResponsable />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/recherche" element={<Recherche />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
        </div>
        <PreventionBar />
        <CookieBanner />
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
